var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fadeInUp","mode":"in-out"}},[_c('div',[_c('HeroSection'),_c('AboutSection'),_c('app-images'),_c('app-download'),_c('ContactUsSection')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }